export default {
  jobListingCandidates: [],
  jobListingCandidate: undefined,
};
